import "./InventoryAddComponent.scss";
import {ITimelineItem} from "../../../shared/models/timeline.model";
import {useNavigate, useSearchParams} from "react-router-dom";
import {useDispatch} from "react-redux";
import React, {useCallback, useEffect, useState} from "react";
import {setCurrentNavParams, setSideMenuView} from "../../../store/actions/header.action";
import {CommonService} from "../../../shared/services";
import {IAPIResponseType} from "../../../shared/models/api.model";
import {ImageConfig} from "../../../constants";
import _ from "lodash";
import Grid from "@mui/material/Grid";
import TimelineComponent from "../../../shared/components/timeline/timelineComponent";
import LottieFileGenarationComponent
    from "../../../shared/components/core/lottie-file-genaration/LottieFileGenarationComponent";
import BasicInformationAddComponent from "./basic-information-add/BasicInformationAddComponent";
import AdditionalDetailsAddComponent from "./additional-details-add/AdditionalDetailsAddComponent";

interface InventoryAddComponentProps {

}

const BASIC_INFORMATION = 'basic_information';
const ADDITIONAL_DETAILS = 'additional_information';

const STEPS: ITimelineItem[] = [
    {
        id: BASIC_INFORMATION,
        title: "Basic Information",
    },
    {
        id: ADDITIONAL_DETAILS,
        title: "Additional Details",
    },
];

const InventoryAddComponent = (props: InventoryAddComponentProps) => {

    const [steps] = useState<ITimelineItem[]>([..._.cloneDeep(STEPS)]);
    const [searchParams, setSearchParams] = useSearchParams();
    const [currentStep, setCurrentStep] = useState<ITimelineItem | undefined>(STEPS[0]);
    const [productId, setProductId] = useState<number | undefined>(undefined);
    const [activeStep, setActiveStep] = React.useState(0);
    const [productDetails, setFacilityDetails] = useState<any>(undefined);
    const [isFacilityDetailsLoading, setIsFacilityDetailsLoading] = useState<boolean>(false);

    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(setCurrentNavParams("", "Inventory"));
        dispatch(setSideMenuView('compact'));
    }, [dispatch]);

    const updateSteps = useCallback((currentStepIndex: number) => {
        setCurrentStep(STEPS[currentStepIndex]);
        searchParams.set("step", STEPS[currentStepIndex].id);
        setSearchParams(searchParams);
        setActiveStep(currentStepIndex);
    }, [searchParams, setSearchParams]);

    const getFacilityDetails = useCallback((productId:number) => {
        const payload = {};
        let productDetails: any = {};
        setIsFacilityDetailsLoading(true);
        CommonService._inventory.getProductDetails(productId, payload)
            .then((response: IAPIResponseType<any>) => {
                if (response?.data) {
                    productDetails = response.data;
                }
                setFacilityDetails(productDetails);
                setIsFacilityDetailsLoading(false);
            })
            .catch((error: any) => {
                // setFacilityDetails(productDetails);
                setIsFacilityDetailsLoading(false);
            });
    }, []);

    const handleFacilityCancel = useCallback(() => {
        CommonService.openConfirmationDialog({
            confirmationTitle: 'Please confirm!',
            confirmationSubTitle: 'Are you sure you want to exit without adding this product?',
            disableEscKeyClose: false,
            disableBackdropClose: true,
            imagePath: `${ImageConfig.ConfirmationImage}`,
            direction: "up",
            yes: {
                text: "Exit",
                color: "primary"
            },
            no: {
                text: "Cancel",
                color: "primary"
            }
        }).then(() => {
            navigate(CommonService._routeConfig.FacilityListRoute());
        }).catch(() => {
            // do nothing;
        });
    }, [navigate]);

    const handleADDSuccess = useCallback(() => {
        CommonService.openConfirmationDialog({
            confirmationTitle: 'Congratulations!',
            confirmationSubTitle: 'Product has been successfully added.',
            disableEscKeyClose: false,
            disableBackdropClose: true,
            imagePath: `${ImageConfig.CongratulationImage}`,
            direction: "up",
            hideNoOption: true,
            yes: {
                text: "Proceed",
                color: "primary"
            }
        }).then(() => {
            navigate(CommonService._routeConfig.InventoryListRoute());
        })
            .catch(() => {
            });
    }, [navigate]);


    const handleNext = useCallback((currentStepIndex: number, currentStepId: string, productId?: number, data?: any) => {
        switch (currentStepId) {
            case BASIC_INFORMATION :
                if (productId) {
                    setProductId(productId);
                    searchParams.set("productId", productId.toString());
                    setSearchParams(searchParams);
                }
                updateSteps(currentStepIndex);
                break;
            case ADDITIONAL_DETAILS:
                handleADDSuccess();
                break;
            default:
                <></>
        }
    }, [searchParams, setSearchParams, updateSteps, handleADDSuccess]);

    useEffect(() => {
        const step = searchParams.get("step");
        setActiveStep(STEPS.findIndex((stepItem: any) => stepItem.id === step));
        const productId = searchParams.get("productId");
        const stepIDS = STEPS.map(item => item.id);
        let stepIndex = 0;
        if (productId) {
            setProductId(parseInt(productId, 10));
            if (stepIDS.indexOf(step) > -1) {
                    stepIndex = stepIDS.indexOf(step);
            } else {
                stepIndex = 1;
            }
        } else {
            stepIndex = 0;
            setActiveStep(0)
        }
        setCurrentStep(STEPS[stepIndex]);
    }, [searchParams]);

    const handlePrevious = useCallback((currentStepIndex: number) => {
        updateSteps(currentStepIndex);
    }, [updateSteps]);

    const renderComponent = useCallback(() => {
        if (!productId) {
            if (currentStep?.id === BASIC_INFORMATION) {
                return <BasicInformationAddComponent
                    next={(productId: number) => handleNext(1, BASIC_INFORMATION, productId)}
                    cancel={handleFacilityCancel}
                />
            }
        } else {
            switch (currentStep && currentStep.id) {
                case BASIC_INFORMATION:
                    return <BasicInformationAddComponent
                        productId={productId}
                        productDetails={productDetails}
                        cancel={handleFacilityCancel}
                        next={(productId: number) => handleNext(1, BASIC_INFORMATION, productId)}
                    />
                case ADDITIONAL_DETAILS:
                    return <AdditionalDetailsAddComponent
                        productId={productId}
                        productDetails={productDetails}
                        cancel={handleFacilityCancel}
                        next={(data: number) => handleNext(2, ADDITIONAL_DETAILS, undefined, data)}
                        prev={() => handlePrevious(0)}
                    />
                default:
                    <></>
            }
        }
    }, [productId, currentStep, handleNext, handleFacilityCancel, handlePrevious, productDetails]);

    useEffect(() => {
        if (productId) {
            getFacilityDetails(productId);
        }
    }, [productId, getFacilityDetails]);


    return (
        <div className="product-creation-layout-screen add-layout-with-timeline screen ">
            <Grid container spacing={2} className="add-form-timeline-wrapper">
                <Grid item sm={12} md={3} xl={3} className="timeline-layout"
                      sx={{
                          display: {xs: "none", md: "block"}
                      }}>
                    <div className="add-layout-title">Adding Product</div>
                    <div className="add-layout-timeline">
                        <TimelineComponent
                            activeStep={activeStep}
                            steps={steps}
                        />
                    </div>
                </Grid>
                <Grid item xs={12} sm={12} md={9} xl={9} className="add-form-content">
                    <div className="add-layout-form-content">
                        {renderComponent()}
                    </div>
                </Grid>
            </Grid>
            {isFacilityDetailsLoading &&
                <div className={"glass-effect h-v-center flex-direction-column"}>
                    <LottieFileGenarationComponent
                        loop={true}
                        autoplay={true}
                        animationData={ImageConfig.LoadingLottieFile}/>
                </div>
            }
        </div>
    )

};

export default InventoryAddComponent;
